const account_center = {
    not_enabled: "Le centre de compte n'est pas activé.",
    filed_not_editable: "Le champ n'est pas modifiable.",
};
export default Object.freeze(account_center);
